import React, { useCallback, useEffect } from 'react';
import RadioButton from '../../../forms/RadioButton';
import { useReframe } from 'nike-re-framejs';
import { makeField, PostProcessor } from 'nike-form-js';
import FieldErrors from '../../../forms/FieldErrors';

function KycQuestionSingle({ form, question }) {
    const { deref } = useReframe();
    const path = [question.type, question.id];
    const radioBtnFormField = makeField(form, path);
    const radioBtnFormFieldValue = deref(radioBtnFormField.getValue());
    const errors = deref(radioBtnFormField.getErrors());
    const isTouched = PostProcessor.isTouchedField(form.deref(), path);

    const initAndTouchSingleOnForm = useCallback(handleOnClick, [radioBtnFormField]);
    useEffect(() => {
        if (!isTouched) {
            initAndTouchSingleOnForm(null);
        }
    }, [isTouched, initAndTouchSingleOnForm]);

    if (!question) {
        return null;
    }

    function handleOnClick(id) {
        radioBtnFormField.setValue(id);
    }

    return (
        <>
            <h1 className="kyc-list-title mt-20 mb-15 fs-16 text-extra-bold">{question.label}</h1>
            {question.option.map(option => (
                <RadioButton
                    className="my-15"
                    key={option.id}
                    active={radioBtnFormFieldValue === option.id}
                    onClick={() => handleOnClick(option.id)}
                >
                    <span>{option.label}</span>
                </RadioButton>
            ))}
            {errors.size > 0 ? <FieldErrors errors={errors} /> : null}
        </>
    );
}

export default KycQuestionSingle;
